import { mediaSrc } from "@/components/ProductMediaUploader";
import { Link } from "react-router-dom";
import { Star, ShieldCheck, Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatINR } from "@/lib/api";

const DOSHA_STYLES = {
  vata: "bg-sky-50 text-sky-800 border-sky-200",
  pitta: "bg-amber-50 text-amber-900 border-amber-200",
  kapha: "bg-emerald-50 text-emerald-900 border-emerald-200",
  tridoshic: "bg-purple-50 text-purple-900 border-purple-200",
};

export default function ProductCard({ product }) {
  const { add } = useCart();
  return (
    <div className="card-warm overflow-hidden group flex flex-col" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block relative aspect-square overflow-hidden bg-[#E8F0EA]">
        <img
          src={mediaSrc(product.image_url)}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <span className={`absolute top-3 left-3 text-[10px] uppercase font-mono px-2 py-0.5 rounded-full border ${DOSHA_STYLES[product.dosha] || DOSHA_STYLES.tridoshic}`}>
          {product.dosha}
        </span>
        {product.original_price && product.original_price > product.price && (
          <span className="absolute top-3 right-3 bg-[#D97706] text-white text-[10px] font-bold px-2 py-1 rounded-full">
            {Math.round(((product.original_price - product.price) / product.original_price) * 100)}% OFF
          </span>
        )}
      </Link>
      <div className="p-4 flex-1 flex flex-col">
        <div className="text-[10px] font-mono uppercase text-[#5A6B5D] flex items-center gap-1">
          <ShieldCheck className="w-3 h-3" /> {product.vendor_name}
        </div>
        <Link to={`/product/${product.id}`}>
          <h3 className="mt-1 font-serif text-lg font-semibold text-[#1A201C] leading-snug line-clamp-2 hover:text-[#1E3A2B]">
            {product.name}
          </h3>
        </Link>
        <div className="mt-1 flex items-center gap-1 text-xs text-[#5A6B5D]">
          <Star className="w-3.5 h-3.5 fill-[#D97706] text-[#D97706]" />
          <span className="font-mono">{product.rating || "New"}</span>
          {product.reviews_count > 0 && <span>({product.reviews_count})</span>}
        </div>
        <div className="mt-3 flex items-end justify-between">
          <div>
            <div className="font-serif text-xl font-bold text-[#1E3A2B]">{formatINR(product.price)}</div>
            {product.original_price && product.original_price > product.price && (
              <div className="text-xs text-[#5A6B5D] line-through">{formatINR(product.original_price)}</div>
            )}
          </div>
          <button
            onClick={() => add(product)}
            className="w-10 h-10 rounded-full bg-[#1E3A2B] text-white flex items-center justify-center hover:bg-[#D97706] transition-colors"
            data-testid={`add-to-cart-${product.id}`}
            aria-label="Add to cart"
          >
            <Plus className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
